export const API = 'https://care-moments-api.dry-rain-8a19.workers.dev';

const APP_SECRET = 'cm-9xK2mP4qR8vN3wL7';

export function apiFetch(url, options = {}) {
  const { headers, ...rest } = options;
  return fetch(url, {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      'X-App-Secret': APP_SECRET,
      ...headers,
    },
  });
}
